import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { store } from "../../../redux/oldStore";
import { IState, ReduxMap } from "../../../redux/redux";
import { ServerResponse } from "../../../utils/Server";
import { IJudge } from "../../JudgingDashboard/Dashboard";
import { ICategoryCaptainInfoSummary, IJudgeInfoSummary, IListItem } from "./CategoryCaptainTypes";
import Button from "../../_Core/Button";
import TagComponent from "../../Tags/TagComponent";
import { Tag } from "../../../utils/CommonTypes/PeoplePageTypes";
import Icon, { IconType } from "../../Icon/Icon";

interface IAssignJudgesToCategoryWizardProps extends IState{

}

interface icategoryStat {
    id:number;
    numberOfProjects:number;
    numberOfJudges:number;
    name:string;
}

const AssignJudgesToCategoryWizard = (props:IAssignJudgesToCategoryWizardProps) =>{
    const [info, setInfo] = useState<ICategoryCaptainInfoSummary>();
    const [tagDic, setTagDic] = useState<Record<number,Tag>>({});
    const [categoryStats, setCategoryStats] = useState<Record<number,icategoryStat>>({});
    const [oldCategoryDic, setOldCategoryDic] = useState<Record<number,number>>({});
    const [stats, setStats] = useState<icategoryStat[]>([]);
    const [showStats, setShowStats] = useState<boolean>(false);
    const [showAssigned, setShowAssigned] = useState<boolean>(true);

    useEffect(()=>{
        init();
    },[]);

    
    useEffect(()=>{
        let stats:Record<number,icategoryStat> = {};

        if(info && info.Judges){

            let list:icategoryStat[] = [];
            info.ProjectsByCategoryStats.forEach(x=>{
                stats[x.CategoryId]={id:+x.CategoryId, numberOfJudges:0,numberOfProjects:x.Number,name:x.CategoryName};
                list.push(stats[x.CategoryId]);
            });
            
            info.Judges.forEach(x=>{
                if(x.AssignedCategory && stats[x.AssignedCategory]){
                    stats[x.AssignedCategory].numberOfJudges++;
                }
            });

            setCategoryStats(stats);
            setStats(list);
        }
    },[info, info?.Judges]);

    const init = () =>{
        store.server
        .getApi<ServerResponse<ICategoryCaptainInfoSummary>>("../JudgingCaptain/InfoSummary")
        .then((x) => {
          if (x.Success) {
            let dic = {};
            x.Value.Tags?.forEach(t=>{
                dic[t.Id] = t;
            });
            setTagDic(dic);
            dic = {};
            x.Value.JudgesOldAssignedCategory?.forEach(j=>{
                dic[j.PersonId] = j.AssignedCategory;
            });
            setOldCategoryDic(dic);
            console.log(dic);
            setInfo(x.Value);

          } else {
            toast.error(x.Message, { autoClose: false });
          }
        });
    };

    const updateCategory = (judge:IJudgeInfoSummary, category:number) =>{
        store.server
        .postApi<ServerResponse<boolean>>("../JudgingCaptain/AssignCategory", {judgeId:judge.PersonId, categoryId:category})
        .then((x) => {
          if (x.Success) {
            let judges = [...info?.Judges ?? []];
            for(let i = 0; i < judges.length; i++){
                let j = judges[i];
                if(j.PersonId === judge.PersonId){
                    j.AssignedCategory = category;
                    break;
                }
            }
            if(info) setInfo({...info,Judges:judges});
          } else {
            toast.error(x.Message, { autoClose: false });
          }
        });
    };

    const buildJudge = (judge:IJudgeInfoSummary, i:number) =>{
        if(!showAssigned && judge.AssignedCategory) return null;

        let tags = judge.TagsCsv?.split(',').map(x=>tagDic[+x]).filter(x=>x);
        if(i < 10) console.log(judge, tags);
        return <div key={`judge-sum-${i}`} className="judge-info">
            <div className="flex-between"><div>
            <span className="name">
            {judge.LastName}, {judge.FirstName}
            </span>
            <div className="tag-bar">
            {tags && tags.map((x,i)=>{
                return <TagComponent key={`judge-tag-${i}`} tag={x} />
            })}
            </div></div>
            {/* <td>{judge.Email}</td>
            <td>{judge.Phone}</td> */}
            <div>
                <select className="form-control"
                    value={judge.AssignedCategory?.toString() ?? '0'}
                    onChange={(e)=>{
                        updateCategory(judge, +e.target.value);
                    }}
                >
                    <option value="0">select</option>
                    {info?.Categories.map((x,i)=>{
                        return <option key={`${judge.PersonId}-cate-id-${i}`} value={x.id}>{x.name}</option>
                    })}
                </select>
                </div>
            </div>
            <div className="judge-prefs">
                {oldCategoryDic[judge.PersonId] &&<span title="Previouse category"><Icon type={IconType.history} /> {info?.CategoryDic[oldCategoryDic[judge.PersonId]]}   </span>}
            {info?.CategoryDic[judge.Category1] && <span>{info?.CategoryDic[judge.Category1]}</span>}
            {info?.CategoryDic[judge.Category2] && <span>{info?.CategoryDic[judge.Category2]}</span>}
            {info?.CategoryDic[judge.Category3] && <span>{info?.CategoryDic[judge.Category3]}</span>}
            </div>
        </div>
    }
    
    return (<>
    <div className="judge-assign-cate-title-bar sticky">
        <div className="flex-between">
    <h3>Assign Judges to Their Category</h3>
    <div className="btn-group">
        <Button onClick={init} text="Refresh" type="refresh" />
        <Button onClick={()=>{setShowStats(!showStats)}} text={showStats ? "Hide Stats": "Show Stats"} 
        type={showStats ? "on":"off"} 
        />
        <Button onClick={()=>{setShowAssigned(!showAssigned)}} text={showAssigned ? "Hide Assigned": "Show Assigned"}
        type={showAssigned ? "on":"off"}
        />
    </div>
    </div>
   {showStats && <div className="stats">
        {stats.map((x,i)=>{
            return <div key={`jactb-s-${i}`}><strong>{x.name}</strong> <span>Judges: {x.numberOfJudges} Projects: {x.numberOfProjects}</span></div>
        })}
    </div>}
    </div>
        

        <div className="assign-judge-wiz">
            
            {/* <div className="search-bar">
                search goes here
            </div> */}
            <div className="judge-list">
                {info && <>
                {info?.Judges?.map(buildJudge)}
                </>
                }
            </div>
        </div>
    </>);
};

export default ReduxMap(AssignJudgesToCategoryWizard);